// extracted by mini-css-extract-plugin
export default {"logo":"Footer_logo__1SLGG","footerBtn":"Footer_footerBtn__mbgoY"};